module.exports = __webpack_public_path__ + "static/media/sel_14_264.e956a5bf.mp4";